<template>
    <router-link :to="{name: name,params: params}">
        <a type="button" @click="sendToParent"
        ><i class="fas table-action-1 "
            :class="{ 'fa-pencil-alt ': params.isEditable, 'fa-info-circle ': !params.isEditable }"
        ></i
        ></a>
    </router-link>
</template>

<script>
    export default {
        name: 'TableEditInfoElement',
        props: {
            name: String,
            params: Object,
            selectedItem: Object
        },
        methods:{
            sendToParent(){
                this.$emit('method', this.selectedItem);
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
